<template>
  <div class="checkout-notify success">
    <div class="checkout-notify-image-wrapper">
      <img class="checkout-notify-image" src="/assets/images/checkout/success.svg"/></div>
    <div class="checkout-notify-info">
      <div class="checkout-notify-info__title">Ваш заказ №{{order.id}}</div>
      <div class="checkout-notify-info__description">Заказ успешно оформлен. В ближайшее время с Вами свяжется оператор.</div>
      <div class="checkout-notify-info__total">Итого: {{ Price.format(order.payTotal) }} руб.</div>
    </div>
  </div>
</template>

<script>
import Price from "../../../tool/Price";

export default {
  name: "CheckoutSuccess",
  computed: {
    Price() {
      return Price
    }
  },
  props: {
    order: Object,
  }
}
</script>